import { useEffect, useState } from "react";
import { message } from "antd";
import screenfull from "screenfull";
import { ExitFullscreenIcon, FullscreenIcon } from "./FullscreenIcons";

/** 全屏按钮，替代旧 fullscreen.vue 并保持 screenfull 状态同步。 */
export function FullscreenButton() {
    const [isFullscreen, setIsFullscreen] = useState(() => screenfull.isFullscreen);

    useEffect(() => {
        if (!screenfull.isEnabled) {
            return undefined;
        }

        const syncFullscreenState = () => setIsFullscreen(screenfull.isFullscreen);
        screenfull.on("change", syncFullscreenState);
        return () => screenfull.off("change", syncFullscreenState);
    }, []);

    const toggleFullscreen = () => {
        if (!screenfull.isEnabled) {
            message.warning("当前您的浏览器不支持全屏 ❌");
            return;
        }
        void screenfull.toggle();
    };

    return (
        <button
            type="button"
            aria-label={isFullscreen ? "退出全屏" : "进入全屏"}
            className="fullscreen"
            onClick={toggleFullscreen}
            style={{
                display: "inline-flex",
                padding: 0,
                color: "#fff",
                background: "transparent",
                border: 0,
                cursor: "pointer"
            }}
        >
            {isFullscreen ? <ExitFullscreenIcon width={20} height={20} /> : <FullscreenIcon width={20} height={20} />}
        </button>
    );
}

export default FullscreenButton;
